import { Icon } from "@iconify/react";
import { Link } from "@tanstack/react-router";
import { Button } from "./ui/button";

export function NotFoundPage() {
  return (
    <div className="min-h-screen bg-background">
      <div className="flex flex-col items-center justify-center h-screen gap-6">
        <Icon
          icon="lucide:compass"
          width={64}
          height={64}
          className="text-muted-foreground"
        />
        <div className="flex flex-col items-center gap-3">
          <h1 className="text-2xl font-semibold">Page not found</h1>
          <p className="text-muted-foreground text-center max-w-md">
            Looks like this page got lost in space.
            <br />
            Let's get you back to where you need to be.
          </p>
        </div>
        <Button asChild size="lg">
          <Link to="/codegen">Go to Code Generation</Link>
        </Button>
      </div>
    </div>
  );
}
